<template>
    <div class="p-3">
        <h3>RL 1.2 Ketersediaan Pelayanan</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Ketersediaan Pelayanan" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="false" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
            ],
            tableOptions: {
                baseUrl: '/api/identitas-rumah-sakit/ketersediaan-pelayanan',
                dataTree: true,
                dataTreeStartExpanded: true,
                layout: "fitColumns",
                columns: [
                    {
                        title: "No",
                        field: "id",
                        formatter: (cell) => {
                            const row = cell.getRow();
                            if (row.getTreeParent()) {
                                // This is a child row
                                return "";
                            }
                            return cell.getValue();
                        },
                        width: 50
                    },
                    {
                        title: "Kategori Pelayanan / Layanan",
                        field: "category",
                        formatter: (cell) => {
                            const row = cell.getRow();
                            if (row.getTreeParent()) {
                                // Indent child rows
                                return `<span style="margin-left: 20px">${cell.getValue()}</span>`;
                            }
                            return cell.getValue();
                        }
                    },
                    {
                        title: "Kondisi",
                        field: "condition",
                        formatter: "tickCross",
                        formatterParams: {
                            allowEmpty: true,
                            tickElement: "✓",
                            crossElement: "✘"
                        },
                        width: 150,
                        hozAlign: "center",
                        cellClick: (e, cell) => {
                            cell.setValue(!cell.getValue());
                        }
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
